import { isBrowser } from 'utils/misc-utils';

// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop = (): Promise<void> => Promise.resolve();

type SegmentOptions = {
  // https://segment.com/docs/connections/sources/catalog/libraries/website/javascript/#managing-data-flow-with-the-integrations-object
  integrations: Record<string, boolean>;
};

const getAnalytics = (): any =>
  window.analytics ?? {
    track: noop,
  };

// https://segment.com/docs/connections/sources/catalog/libraries/website/javascript/
export const createSegmentClient = (): SegmentClient => {
  if (!isBrowser()) {
    return {
      track: noop,
    };
  }

  return {
    // https://segment.com/docs/connections/sources/catalog/libraries/website/javascript/#track
    track(event: string, properties?: unknown, options?: SegmentOptions): Promise<void> {
      return new Promise((resolve) => {
        getAnalytics().track(event, properties, options, () => resolve());
      });
    },
  };
};

export type SegmentClient = {
  track(event: string, properties?: unknown, options?: SegmentOptions): Promise<void>;
};
